import { useState, useEffect } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import MainTitle from '../../components/MainTitle'
import { useParams, useLocation, useNavigate } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'
import ClientNav from '../../components/ClientNav'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan, faXmarkCircle } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'
import Modal from '../../components/Modal'
function Interactions() {
  const [notes, setNotes] = useState([])
  const [deleteNote, setDeleteNote] = useState({})
  const [addNoteTitle, setAddNoteTitle] = useState('')
  const [addNoteBody, setAddNoteBody] = useState('')
  const [noteDate, setNoteDate] = useState('')
  const [noteTime, setNoteTime] = useState('')
  const [addNotePrivate, setAddNotePrivate] = useState(1)
  const { id } = useParams()
  const { setShowLoader, can, createInfo, auth } = useAuth()
  const [searchTerm, setSearchTerm] = useState('')
  const [typeFilter, setTypeFilter] = useState('')
  const [sortOrder, setSortOrder] = useState('desc')

  const [clientData, setClientData] = useState({
    name: '',
    reference: 'WBA-1000',
  })

  const [showModal, setShowModal] = useState(false)
  const [modalTitle, setModalTitle] = useState('')
  const axios = useAxiosPrivate()

  const getNotesByClientId = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/interaction/all/${id}`)
      if (response.data.result) {
        await setNotes(response.data.result)
      }
    } catch (error) {}
    setShowLoader(false)
  }

  const resetModal = (resetNotes = true) => {
    setDeleteNote({})
    setShowModal(false)
    if (resetNotes) {
      setNotes(notes)
    }
  }

  const createNote = async (e) => {
    e.preventDefault()
    setShowLoader(true)
    try {
      const response = await axios.post(`/interaction/create`, {
        created_by: auth.user.id,
        type: addNoteTitle,
        body: addNoteBody,
        is_private: 0,
        interaction_date: noteDate,
        interaction_time: noteTime,
        client_id: clientData.id,
      })

      createInfo('success', `Note Added`)
      setNotes([...notes, response.data.result])
      setNoteDate('')
      setNoteTime('')
      setAddNoteTitle('')
      setAddNoteBody('')
      setAddNotePrivate(0)
      getNotesByClientId()
    } catch (error) {
      createInfo('error', `Failed to create note`)
    }
    setShowLoader(false)
  }

  const DeleteNoteElement = () => {
    const deleteNoteFn = async (e) => {
      e.preventDefault()
      setShowLoader(true)
      resetModal(false)
      try {
        const response = await axios.get('/interaction/delete/' + deleteNote.id)
        createInfo('error', `Note Deleted: ${deleteNote.type}`)
        setShowLoader(false)
        getNotesByClientId()
      } catch (error) {
        setShowLoader(false)
      }
    }

    return (
      <form onSubmit={deleteNoteFn}>
        <div className="mb-3">
          <p className="text-base font-bold my-8 text-center">
            {deleteNote.body}
          </p>
          <p className="text-base font-bold my-8 text-center">
            Are you sure you want to delete this note?
          </p>
          <div className="flex mt-2 w-full">
            <button className="btn red mt-4 mr-4 w-1/2">Delete Note</button>

            <button
              type="button"
              className="btn mt-4 w-1/2"
              onClick={resetModal}
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    )
  }

  const ModalBody = () => {
    if (deleteNote.id) {
      return <DeleteNoteElement />
    }
  }

  const deleteNoteClicked = (note) => {
    setDeleteNote({ ...note })
    setModalTitle(`Delete Note: ${note.type}`)
    setShowModal(true)
  }

  const getClientById = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/clients/${id}`)
      await setClientData(response.data.result)
      setShowLoader(false)
    } catch (error) {}
  }

  useEffect(() => {
    getClientById()
    getNotesByClientId()
  }, [])

  const filteredAndSortedNotes = Array.isArray(notes)
    ? notes
        .filter((note) => {
          if (!note || typeof note !== 'object') return false

          const search = searchTerm.toLowerCase()
          const matchText =
            note.title?.toLowerCase().includes(search) ||
            note.body?.toLowerCase().includes(search) ||
            note.type?.toLowerCase().includes(search) ||
            note.created_by_user?.toLowerCase().includes(search)

          const matchesType = typeFilter ? note.type === typeFilter : true
          return matchText && matchesType
        })
        .sort((a, b) => {
          const dateA = new Date(`${a.interaction_date} ${a.interaction_time}`)
          const dateB = new Date(`${b.interaction_date} ${b.interaction_time}`)
          return sortOrder === 'asc' ? dateA - dateB : dateB - dateA
        })
    : []

  return (
    <section className="relative">
      {showModal && (
        <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
      )}
      <MainTitle
        title={`Client: ${clientData.name} (${clientData.reference})`}
        client={clientData}
        backButton
        child={clientData.child}
        discharge
        waiting
      />
      <ClientNav active="interactions" client={clientData} />

      <section>
        <section className="w-full mb-8">
          <h2 className="font-bold text-xl mb-2 mt-2">Interactions</h2>
          <div className="flex flex-row">
            <div className="w-1/3">
              <div className=" bg-white rounded-xl shadow-md py-4 px-4 mr-2">
                <form onSubmit={createNote}>
                  <div>
                    <select
                      className="px-4 border-t border-l border-r w-full"
                      value={addNoteTitle}
                      onChange={(e) => setAddNoteTitle(e.target.value)}
                      required
                    >
                      <option value="">Select Note Type</option>
                      <option value="Phone Call with Client">
                        Phone Call with Client
                      </option>
                      <option value="Email with Client">
                        Email with Client
                      </option>
                      <option value="Email with Counsellor/Admin">
                        Email with Counsellor/Admin
                      </option>
                      <option value="Internal Log">Internal Log</option>
                    </select>

                    <input
                      type="date"
                      className="w-full border-t border-l border-r px-4 py-3"
                      value={noteDate}
                      onChange={(e) => setNoteDate(e.target.value)}
                      required
                    />

                    <input
                      type="time"
                      className="w-full border-t border-l border-r px-4 py-3"
                      value={noteTime}
                      onChange={(e) => setNoteTime(e.target.value)}
                    />

                    <textarea
                      required
                      className="w-full border rounded-sm py-4 px-4"
                      value={addNoteBody}
                      onChange={(e) => setAddNoteBody(e.target.value)}
                      placeholder="Please type here to add notes"
                    ></textarea>

                    {/* {can('add private note') && (
                      <div className="flex items-center mb-4">
                        <input
                          id="note-checkbox"
                          type="checkbox"
                          checked={addNotePrivate}
                          onChange={(e) => setAddNotePrivate(e.target.checked)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
                        />
                        <label
                          htmlFor="note-checkbox"
                          className="ml-2 text-sm font-medium text-gray-900"
                        >
                          Make note private
                        </label>
                      </div>
                    )} */}

                    <div className="flex justify-end">
                      <button className="btn mt-4 mr-4">Add Note</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="px-4 w-2/3 overflow-y-scroll mr-2 max-h-screen bg-white rounded-xl shadow-md py-4 mx-2">
              <div className="flex justify-between items-center mb-4 w-full">
                <div className="relative w-1/4 xl:w-1/3">
                  <input
                    type="text"
                    placeholder="Search interactions..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="border rounded px-3 py-2 w-full pr-10"
                  />
                  {searchTerm && (
                    <FontAwesomeIcon
                      icon={faXmarkCircle}
                      className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                      onClick={() => setSearchTerm('')}
                    />
                  )}
                </div>

                <div>
                  <select
                    value={typeFilter}
                    onChange={(e) => setTypeFilter(e.target.value)}
                    className="border rounded px-3 py-2"
                  >
                    <option value="">All Types</option>
                    <option value="Phone Call with Client">
                      Phone Call with Client
                    </option>
                    <option value="Email with Client">Email with Client</option>
                    <option value="Email with Counsellor/Admin">
                      Email with Counsellor/Admin
                    </option>
                    <option value="Internal Log">Internal Log</option>
                  </select>

                  <select
                    value={sortOrder}
                    onChange={(e) => setSortOrder(e.target.value)}
                    className="border rounded px-3 py-2 ml-1"
                  >
                    <option value="desc">Newest to Oldest</option>
                    <option value="asc">Oldest to Newest</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-2">
                {filteredAndSortedNotes?.map((note) => {
                  console.log(note)
                  return note?.is_private === 1 && can('view private notes') ? (
                    <div className="border rounded px-4 mb-2">
                      <div className="flex justify-between py-2">
                        <div className="">
                          <span className="py-2">{note.type}</span>
                        </div>
                        {can('delete notes') && (
                          <div className="justify-end">
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              className="text-red-500"
                              onClick={() => deleteNoteClicked(note)}
                            />
                          </div>
                        )}
                      </div>
                      <hr />
                      <p className="py-2">{note.body}</p>
                      <div className="text-sm text-gray-600 mb-1">
                        Interaction on{' '}
                        {moment(note.interaction_date).format('DD/MM/YYYY')} at{' '}
                        {note.interaction_time?.slice(0, 5)}
                      </div>
                      <div className="py-2 flex justify-between">
                        <div>
                          <span className="text-xs py-2">
                            created By {note.created_by_user} on&nbsp;
                            {moment(note.created_at).format('DD/MM/YYYY HH:mm')}
                          </span>
                        </div>
                        <div className="justify-end">
                          {note.is_private === 1 ? (
                            <span className="status private">Private</span>
                          ) : (
                            <span className="status public">Public</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : note?.is_private === 0 ? (
                    <div className="border rounded px-4 mb-2">
                      <div className="flex justify-between py-2">
                        <div className="">
                          <span className="py-2">{note.type}</span>
                        </div>
                        <div className="justify-end">
                          <FontAwesomeIcon
                            icon={faTrashCan}
                            className="text-red-500"
                            onClick={() => deleteNoteClicked(note)}
                          />
                        </div>
                      </div>
                      <hr />
                      <p className="py-2">{note.body}</p>
                      <div className="text-sm text-gray-600 mb-1">
                        Interaction on{' '}
                        {moment(note.interaction_date).format('DD/MM/YYYY')} at{' '}
                        {note.interaction_time?.slice(0, 5)}
                      </div>
                      <div className="py-2 flex justify-between">
                        <div>
                          <span className="text-xs py-2">
                            created By {note.created_by_user} on&nbsp;
                            {moment(note.created_at).format('DD/MM/YYYY HH:mm')}
                          </span>
                        </div>
                        <div className="justify-end">
                          {note.is_private === 1 ? (
                            <span className="status private">Private</span>
                          ) : (
                            <span className="status public"> Public</span>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : null
                })}
              </div>
            </div>
          </div>
        </section>
      </section>
    </section>
  )
}

export default Interactions
